module.exports = __webpack_public_path__ + "img/whisky.e863ac2d.png";